import { useEffect } from "react";

/**
 * Site-wide Facebook/Instagram-style hide-on-scroll for the global fixed top Navbar.
 * Mobile only (<=1023px). Toggles `body.feed-header-hidden` which the CSS in
 * src/index.css uses to translate `nav.fixed.top-0` off-screen.
 */
const GlobalHeaderHideOnScroll = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - lastY;
        if (y < 60) document.body.classList.remove("feed-header-hidden");
        else if (delta > 6) document.body.classList.add("feed-header-hidden");
        else if (delta < -6) document.body.classList.remove("feed-header-hidden");
        lastY = y;
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.body.classList.remove("feed-header-hidden");
    };
  }, []);
  return null;
};

export default GlobalHeaderHideOnScroll;